var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","elevation":"0","height":_vm.headerHeight}},[_c('div',{staticClass:"survey-header"},[_c('img',{staticClass:"survey-header-logo",attrs:{"src":_vm.getLogo,"alt":"Logo da loja"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }